import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import Icon from '@minecraft.icon';

import { MediaRequestMedia } from '../../../types';

const StyledName = styled.div`
  display: inline-block;
  margin-left: 0.2rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export type sizeType = 'xxsm' | 'xsm' | 'sm' | 'md' | 'modal' | 'lg';

// [width, height]
const fixedHeight = 40;
const sizes: Record<sizeType, [number, number]> = {
  xxsm: [40, fixedHeight],
  xsm: [144, fixedHeight],
  sm: [256, fixedHeight],
  md: [353, fixedHeight],
  modal: [560, fixedHeight],
  lg: [704, fixedHeight],
};

type Props = {
  type?: sizeType;
  media: MediaRequestMedia;
  customSize?: [number, number];
};

const DocumentMedia = ({ media, type = 'sm', customSize }: Props) => {
  const [width, height] = _isEmpty(customSize) ? sizes[type] : customSize;

  const nameWidth = width - 40;

  return (
    <Wrapper style={{ width, height }}>
      <Icon name="document" />
      <StyledName style={{ width: nameWidth }}>{media.name}</StyledName>
    </Wrapper>
  );
};

export default React.memo(DocumentMedia);
